import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Heading,
  HStack,
} from "@chakra-ui/react";
import CodesetSelect from "./CodesetSelect";
import CodesetSelectWithFilters from "./CodesetSelectWithFilters";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";

const ClassificationsEditor = ({
  classifications = [],
  onChange,
  defaultType = "",
  filter = null,
  size = "md",
}) => {
  const [localClassifications, setLocalClassifications] = useState(classifications);

  useEffect(() => {
    setLocalClassifications(classifications);
  }, [classifications]);

  const handleChange = (index, field, value) => {
    const updated = [...localClassifications];
    updated[index][field] = value;
    setLocalClassifications(updated);
    onChange(updated);
  };

  const handleAdd = () => {
    const newEntry = {
      type: defaultType,
      agencyCode: "",
      agencyCodeSetCode: "",
      description: "",
      code: "",
      ruleCode: ""
    };
    const updated = [...localClassifications, newEntry];
    setLocalClassifications(updated);
    onChange(updated);
  };

  const handleDelete = (index) => {
    const updated = [...localClassifications];
    updated.splice(index, 1);
    setLocalClassifications(updated);
    onChange(updated);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} borderColor="gray.500">
      <HStack mb={3} justifyContent="flex-start">
        <Heading size={size}>Classifications</Heading>
        <IconButton icon={<HiOutlinePlus />} size={size} onClick={handleAdd} />
      </HStack>

      <Table variant="simple" size={size}>
        <Thead>
          <Tr>
            <Th fontSize={size}>Type</Th>
            <Th fontSize={size}>Agency</Th>
            <Th fontSize={size}>Code Set</Th>
            <Th fontSize={size}>Code</Th>
            <Th fontSize={size}>Description</Th>
            <Th fontSize={size}>Rule</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {localClassifications.map((cls, idx) => (
            <Tr key={idx}>
              <Td>
                <CodesetSelectWithFilters
                  codesetCode="T03"
                  // If filter is provided, pass it to CodesetSelect
                  filter={filter ? filter : null}
                  value={cls.type ? { code: cls.type, description: "" } : null}
                  onChange={(val) => {
                    handleChange(idx, "type", val.code);
                    handleChange(idx, "agencyCode", val.codeListAgency);
                    handleChange(idx, "agencyCodeSetCode", val.codeListSource);
                  }}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode="3055"
                  value={cls.agencyCode ? { code: cls.agencyCode, description: "" } : null}
                  onChange={(val) => handleChange(idx, "type", val.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode="C01"
                  // If filter is provided, pass it to CodesetSelect
                  filter={filter ? filter : null}
                  value={cls.agencyCodeSetCode ? { code: cls.agencyCodeSetCode, description: "" } : null}
                  onChange={(val) => {
                    handleChange(idx, "agencyCodeSetCode", val.code);
                    handleChange(idx, "agencyCode", val.codeListAgency || "");
                }}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode={cls.agencyCodeSetCode}
                    value={cls.code ? { code: cls.code, description: "" } : null}
                    onChange={(val) => handleChange(idx, "code", val.code)}
                    size={size}
                    height="32px"
                />
              </Td>
              <Td>
                <Input
                  size={size}
                  height="32px"
                  value={cls.description}
                  onChange={(e) => handleChange(idx, "description", e.target.value)}
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode="B60"
                  value={cls.ruleCode ? { code: cls.ruleCode, description: "" } : null}
                  onChange={(val) => handleChange(idx, "ruleCode", val.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <IconButton
                  icon={<HiOutlineTrash />}
                  size={size}
                  onClick={() => handleDelete(idx)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default ClassificationsEditor;
